export const featherySdkKey = '49a1ad21-a550-45d8-8a57-7b490f435b3d';
export const featheryPlantTouchingRoles = [
  'Cannabis Retail',
  'Cannabis Cultivator',
  'Cannabis Extractor / Processor / Manufacturer',
  'Distributor / Delivery',
  'Vertically Integrated',
  'Other/Unknown Cannabis Company'
];
